module.exports = __webpack_public_path__ + "static/yun-ec956effde015790bcd68de691f0ef72.jpg";